import { render, staticRenderFns } from "./Puno.vue?vue&type=template&id=70af1bb8&"
import script from "./Puno.vue?vue&type=script&lang=js&"
export * from "./Puno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports